import type { NotificationResponse } from '../types/notification.types'

/** Un aviso suelto o varios del mismo tipo juntos («8 mesas nuevas cerca de ti»). */
export type NotificationEntry =
  | { kind: 'single'; notification: NotificationResponse }
  | { kind: 'group'; type: string; items: NotificationResponse[] }

/**
 * Junta los avisos del mismo tipo (spec `2026-11-03-campana-pestanas`, R4). El grupo ocupa el
 * sitio del más reciente de su tipo y conserva el orden de llegada dentro; un tipo con un solo
 * aviso se queda suelto. Trabaja sobre la página cargada.
 */
export function groupNotifications(list: NotificationResponse[]): NotificationEntry[] {
  const byType = new Map<string, NotificationResponse[]>()
  for (const n of list) {
    const items = byType.get(n.type)
    if (items) items.push(n)
    else byType.set(n.type, [n])
  }
  const entries: NotificationEntry[] = []
  const placed = new Set<string>()
  for (const n of list) {
    if (placed.has(n.type)) continue
    placed.add(n.type)
    const items = byType.get(n.type)!
    entries.push(
      items.length > 1
        ? { kind: 'group', type: n.type, items }
        : { kind: 'single', notification: n },
    )
  }
  return entries
}

/** Lo que identifica a un aviso en la línea de resumen del grupo: el juego, el título o la tienda. */
export function notificationSubject(n: NotificationResponse): string | null {
  return (
    n.sessionBaseGameName?.trim() ||
    n.sessionTitle?.trim() ||
    n.playIntentGameName?.trim() ||
    n.storeName?.trim() ||
    n.title?.trim() ||
    null
  )
}
